import {home} from './Home/sl'
import {login} from './Login/sl'
import {registration} from './Registration/sl'
import {onboarding} from './Onboarding/sl'
import {forgotPassword} from './ForgotPassword/sl'
import {resetPassword} from './ResetPassword/sl'
import {contactData} from './ContactData/sl'
import {consents} from './Consents/sl'
import {profile} from './Profile/sl'
import {candidateDashboard} from './Dashboard/sl'
import {CandidateInfo} from './CandidateInfo/sl'
import {CandidateFAQ} from './CandidateFAQ/sl'

export const seeker = {
  ...home,
  ...login,
  ...registration,
  ...onboarding,
  ...forgotPassword,
  ...resetPassword,
  ...contactData,
  ...consents,
  ...profile,
  ...candidateDashboard,
  ...CandidateInfo,
  ...CandidateFAQ,
}
